import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const filaVacia = () => ({ porcentaje: "", base: "", cuota: "" });

export function ivasFromApi(list) {
  if (!list?.length) return [];
  return list.map((r) => ({
    porcentaje: r.porcentaje != null ? String(r.porcentaje).replace(".", ",") : "",
    base: r.base != null ? String(r.base).replace(".", ",") : "",
    cuota: r.cuota != null ? String(r.cuota).replace(".", ",") : "",
  }));
}

export function ivasToJson(rows) {
  const out = rows
    .filter((r) => r.porcentaje && r.base && r.cuota)
    .map((r) => ({
      porcentaje: parseFloat(String(r.porcentaje).replace(",", ".")),
      base: String(r.base).replace(",", "."),
      cuota: String(r.cuota).replace(",", "."),
    }))
    .filter((r) => !Number.isNaN(r.porcentaje));
  return out.length ? JSON.stringify(out) : "";
}

export default function GastoIvasEditor({ ivas, onChange, avisoSinDesglose, avisoCalculado }) {
  const filas = ivas.length ? ivas : [];

  const actualizar = (idx, campo, valor) => {
    const next = [...filas];
    next[idx] = { ...next[idx], [campo]: valor };
    onChange(next);
  };

  const anadir = () => onChange([...filas, filaVacia()]);
  const quitar = (idx) => onChange(filas.filter((_, i) => i !== idx));

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <Label>Desglose de IVA</Label>
        <Button type="button" variant="outline" size="sm" className="h-7 gap-1 text-xs" onClick={anadir}>
          <Plus className="h-3 w-3" /> Añadir tramo
        </Button>
      </div>
      {avisoCalculado && filas.length > 0 && (
        <p className="text-xs text-amber-700">
          Desglose calculado a partir del total y el IVA detectado. Verifica base y cuota antes de registrar.
        </p>
      )}
      {avisoSinDesglose && filas.length === 0 && (
        <p className="text-xs text-amber-700">El ticket indica IVA incluido pero sin desglose de bases y cuotas.</p>
      )}
      {filas.length === 0 ? (
        <p className="text-xs text-zinc-500">Sin desglose detectado. Añade tramos manualmente si procede.</p>
      ) : (
        <div className="space-y-2">
          <div className="grid grid-cols-[4rem_1fr_1fr_2rem] gap-2 text-[10px] font-semibold uppercase tracking-wide text-zinc-500">
            <span>IVA %</span>
            <span>Base</span>
            <span>Cuota</span>
            <span />
          </div>
          {filas.map((f, idx) => (
            <div key={idx} className="grid grid-cols-[4rem_1fr_1fr_2rem] gap-2">
              <Input
                inputMode="decimal"
                placeholder="21"
                value={f.porcentaje}
                onChange={(e) => actualizar(idx, "porcentaje", e.target.value)}
              />
              <Input
                inputMode="decimal"
                placeholder="0,00"
                value={f.base}
                onChange={(e) => actualizar(idx, "base", e.target.value)}
              />
              <Input
                inputMode="decimal"
                placeholder="0,00"
                value={f.cuota}
                onChange={(e) => actualizar(idx, "cuota", e.target.value)}
              />
              <Button type="button" variant="ghost" size="icon" className="h-9 w-8 text-zinc-400" onClick={() => quitar(idx)}>
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
